// imports
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Define a custom styled Typography
const ReusableMenuTypography = styled(Typography)(() => ({
  fontWeight: 'bold',
  marginBottom: '5px',
  color: 'black',
  textAlign: 'left',
  fontSize: '1.125rem',
}));

export default ReusableMenuTypography;
